import React, { Component } from 'react';
import {animateScroll} from 'react-scroll';
import {Link} from 'react-router-dom';

export default class Footer extends Component {
	scrollToTop() {
		animateScroll.scrollToTop();
		// onClick={this.scrollToTop}
		//<span><i className="fa fa-angle-up" onClick={this.scrollToTop}></i></span>
	}

  render() {
    return (

      	<div className="container">
			<div className="row">
				<div className="col-md-12 footer">
					
					<p className="text-center mb0">
						Copyright &copy; 2017. All Right Reserved.
						<Link to="/login"> AndriDeng</Link>
					</p>
				</div>
			</div>
		</div>
      
    );
  }
}





// WEBPACK FOOTER //
// ./src/guest/components/Footer.js